module.exports = __webpack_public_path__ + "img/diversity-zain-team.a14d2104.png";